namespace $.$$ {
	export class $shm_hitalama_guide_item extends $.$shm_hitalama_guide_item {
		title() { return this.catalog().group(this.id())?.title()??this.catalog().page(this.id())!.read().title }
		page_arg() { return { guide_page: this.id() } }
		content() { return this.renaming()?[this.Input()]:[this.catalog().group(this.id())?this.Menu():this.Link()] }
		menu_content() { return this.catalog().can_change()?[this.Delete()]:[] }
		@ $mol_mem
		renaming( next=false ) { return next }
		@ $mol_mem
		draft( next?: string ) { return next??this.title() }
		@ $mol_action
		contextmenu( event?: MouseEvent ) { if(event&&this.catalog().can_change()){event.preventDefault();event.stopPropagation();this.Menu().showed(true)}return null }
		@ $mol_action
		rename_start( event?: Event ) {
			if(!event||!this.catalog().can_change())return null
			event.preventDefault();event.stopPropagation();this.Menu().showed(false);this.draft(this.title());this.renaming(true)
			new this.$.$mol_after_frame(()=>{this.Input().focused(true);this.Input().selection([0,this.draft().length])});return null
		}
		@ $mol_action
		rename_submit( event?: Event ) { if(event&&this.renaming()){if(this.draft().trim())this.catalog().group(this.id())!.title(this.draft().trim());this.renaming(false)}return null }
		@ $mol_action
		rename_keydown( event?: KeyboardEvent ) { if(event?.key==='Escape'){event.preventDefault();event.stopPropagation();this.renaming(false)}return null }
		@ $mol_action
		input_pointerdown( event?: Event ) { event?.stopPropagation();return null }
		@ $mol_action
		remove( event?: Event ) { if(event){$mol_wire_sync(this.catalog()).group_remove(this.id());this.Menu().showed(false)}return null }
	}
}
